export default "/images/company.svg?836a5283fa9db003b8901a46d1f5f1c8";